import '@/mikan/_shared/lib/polyfills';
import Vue from 'vue';
import registerRollbar from '@/mikan/_shared/plugins/registerRollbar';
import viewModelRegister from '@/mikan/_shared/lib/utilities/viewModelRegister';

import commonComponents from '@/mikan/pc/entries/commonComponents';
import ForgotLoginMail from '@/mikan/pc/components/pages/Auth/ForgotLoginMail.vue';

Vue.config.productionTip = false;
registerRollbar(Vue);

viewModelRegister({
  ...commonComponents,
  '#js-auth-forgot-login-mail': {
    components: {
      ForgotLoginMail,
    },
  },
});
